import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsHeroHeader extends Component {
  // Services
  @service intl;

  // Defaults
  alignments = [0, 1, 2];

  // Getter and setter
  get alignmentOptions() {
    return labelValueOptions.call(this, this.alignments, [
      'forms.hero-header.options.alignment',
    ]);
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='content' as |fieldset|>
            <fieldset.field @property='headline' />
            <fieldset.field @property='text' @type='text-editor' />
            <fieldset.field
              @filters={{hash assetFolderId='8'}}
              @property='logo'
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='alignment'
              @type='select-value'
              @options={{this.alignmentOptions}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='button' as |fieldset|>
            <fieldset.field @property='buttonText' />

            <fieldset.field @property='hideButton' @type='checkbox' />
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
